import React from "react";
import TakeExamState, { TakeExamProps } from "./TakeExam.models";
import ExamService from "../../../services/exam/ExamService";
import ExamQuestionView from "../exam-question-view/ExamQuestionView";
import './TakeExam.scss';
import { ExamQuestionsView } from "../../../models/dtos/exams/questions/ExamQuestionsView";
// import moment from "moment";
import ExamResultService from "../../../services/exam/ExamResultService";
import { QuestionBaseJson } from "../../../models/dtos/exams/questions/QuestionBaseJson";
import StudentAnswerView from "../../../models/dtos/exams/questions/StudentAnswerView";
import { ExamResultEditionDTO } from "../../../models/dtos/exams/exam/ExamResultEditionDTO";
import { ExamStudentAnswerDTO } from "../../../models/dtos/exams/exam/ExamStudentAnswerDTO";

export default class TakeExam extends React.PureComponent<TakeExamProps, TakeExamState> {
    examService: ExamService;
    examResultService: ExamResultService;
    constructor(props: any) {
        super(props);
        this.examService = new ExamService();
        this.examResultService = new ExamResultService();
        this.state = {
            studentAnswers: [], examTimeExpired: false, questions: [], showAllQuestion: false, examId: 0, examResultId: 0
            , examTimeCountDownText: '',
            timer: new Date()
        };
    }


    getLocalTime(date: Date) {
        const hours = date.getHours();
        const minutes = date.getMinutes();
        const seconds = date.getSeconds();

        return `${hours}:${minutes}:${seconds}`;
    }

    calculateDifference = (startTime: Date, endTime: Date) => {
        const timeDiff = endTime.getTime() - startTime.getTime();
        const diffDays = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
        const diffHours = Math.floor((timeDiff / (1000 * 60 * 60)) % 24);
        const diffMinutes = Math.floor((timeDiff / (1000 * 60)) % 60);
        const diffSeconds = Math.floor((timeDiff / 1000) % 60);

        return (`${diffHours}:${diffMinutes}:${diffSeconds}`);
    };

    componentDidMount() {
        this.setParams(this.props.examId, this.props.examResultId);
        this.getExamDateTime(Number(this.props.examId));

        this.getData();
        // var localTime = this.getLocalTime(new Date());
        setInterval(() => {
            if (this.state.examEndTime !== undefined && this.state.examEndTime !== null) {
                this.setExamTime(this.state.examEndTime);
                // // var x = this.examService.getServerTime();
                // console.log('server time', (new Date()) )
                // console.log('server exam', new Date(this.state.examEndTime) )
                // console.log('server diff', this.calculateDifference(new Date(),new Date(this.state.examEndTime)) )

                // console.log('server examTime', this.formatTime((new Date(this.state.examEndTime)).getTime() - (new Date()).getTime()))
            }
        }, 1000)

        if (localStorage.getItem("exam_student_answers")) {
            localStorage.removeItem("exam_student_answers");
        }
    }

    formatTime(milliseconds: number) {
        const date = new Date(milliseconds);
        const hours = date.getHours();
        const minutes = date.getMinutes();
        const seconds = date.getSeconds();
        return `${hours}:${minutes}:${seconds}`;
    }

    componentDidUpdate(prevProps: any) {
        if (prevProps.examId !== this.props.examId && prevProps.examResultId !== this.props.examResultId) {
            this.setParams(this.props.examId, this.props.examResultId);
            this.getData();
        }
    }

    setParams = (examId?: string | null, examResultId?: string | null) => {
        if ((examId !== undefined && examId !== null) && (examResultId !== undefined && examResultId !== null)) {

            let examResult = Number(examResultId);
            let exam = Number(examId);
            this.setState({ examId: exam, examResultId: examResult });
        }
    }

    setExamTime = (examDateTime: Date) => {
        if (!this.state.examTimeExpired) {
            // var exmaDate = moment(examDateTime);
            var newDate = new Date();

            // var diffDuration = exmaDate.diff(newDate);
            // var remainingTime = moment.duration(diffDuration);

            const timeDiff = new Date(examDateTime).getTime() - (new Date()).getTime();
            const diffHours = Math.floor((timeDiff / (1000 * 60 * 60)) % 24);
            const diffMinutes = Math.floor((timeDiff / (1000 * 60)) % 60);
            const diffSeconds = Math.floor((timeDiff / 1000) % 60);

            var stringHours = diffHours > 9 ? `${diffHours}` : `0${diffHours}`
                , stringMinutes = diffMinutes > 9 ? `${diffMinutes}` : `0${diffMinutes}`
                , stringSeconds = diffSeconds > 9 ? `${diffSeconds}` : `0${diffSeconds}`

            var remainingTime = diffHours <= 0 && diffMinutes <= 0 && diffSeconds <= 0 ? null :
                (`${stringHours}:${stringMinutes}:${stringSeconds}`);

            var time = new Date(newDate.getFullYear(), newDate.getMonth(), newDate.getDay(), diffHours, diffMinutes, diffSeconds);

            if ((remainingTime === null || remainingTime === undefined) && diffHours <= 0 && diffMinutes <= 0 && diffSeconds <= 0) {
                // question.EndedExam = endedExam;
                this.setState({ examTimeExpired: true, examTimeCountDownText: "پایان آزمون" });
                this.endExam()
            }
            else {
                this.setState({ examTimeExpired: false, examTimeCountDownText: remainingTime as string, timer: time });
            }
        }
    }

    getExamDateTime = (examId: number) => {
        let self = this;
        this.examResultService.getDateTime(examId).then(function (response) {

            var endExam = new Date();
            endExam.setMinutes(endExam.getMinutes() + response);
            endExam = new Date(endExam);
            self.setState({ examEndTime: endExam });
        });
    }

    getData = () => {
        let self = this;
        let data: StudentAnswerView[] = JSON.parse(localStorage.getItem("exam_student_answers") as string);
        data = data ?? [];

        self.examService.getQuestionListByID(Number(this.props.examId)).then(function (response) {
            self.setState({ questions: response.questions.sort((a, b) => { return a.orderId - b.orderId }), studentAnswers: data, courseIds: response.courseIds, structure: response.structure }, () => {
                self.examResultService.getExamResultReport(Number(self.props.examId), Number(self.props.examResultId)).then(studentExamResult => {
                    if (studentExamResult != null) {
                        self.setState(
                            {
                                studentAnswers: studentExamResult.map(item => { return { ...self.state.questions.filter(question => question.questionId)[0], questionId: item.questionStoreID, answer: { isWhichOption: item.studetnSelectedAnswer } } })
                            }, () => console.log(self.state.studentAnswers)
                        )
                    }
                })
            });
        });
    }

    endExam = () => {
        let data: StudentAnswerView[] = JSON.parse(localStorage.getItem("exam_student_answers") as string);
        data = data ?? [];
        let { examResultId } = this.props;

        var examResultEdition = this.mappingData(data);
        this.examResultService.endExam(examResultEdition).then(function (response) {
            if (response != null) {
                localStorage.removeItem("exam_student_answers");

                window.location.href = `/StudentExamSummary?examResultId=${examResultId}`;
            }
        });

    }

    mappingData = (data: StudentAnswerView[]): ExamResultEditionDTO => {
        let { examId, examResultId } = this.props;
        var studentAnswers: ExamStudentAnswerDTO[] = data.map(studentAnswer => {
            let answers: QuestionBaseJson[] = [];
            answers.push(studentAnswer.answer);

            let mapResult: ExamStudentAnswerDTO = {
                questionAttachmentId: studentAnswer.questionAttachmentId,
                additionalAttachmentId: studentAnswer.additionalAttachmentId,
                questionTitle: studentAnswer.questionTitle,
                questions: answers,
                courseId: studentAnswer.questionCourseId,
                isAnswerCorrect: false,
                questionStoreID: studentAnswer.questionId,
                studentExamQuestionAnswerId: Number(this.props.examId),
                studentExamResultID: Number(this.props.examResultId),
                studentUserID: '',
                studetnSelectedAnswer: studentAnswer.answer.isWhichOption,
            }

            return mapResult;
        });

        var examResultEdition: ExamResultEditionDTO = {
            id: Number(examResultId),
            studentExamId: Number(examId),
            examStudentAnswers: studentAnswers
        };

        return examResultEdition;
    }

    updateExam = (question: ExamQuestionsView, answerSelected: QuestionBaseJson) => {
        let data: StudentAnswerView[] = JSON.parse(localStorage.getItem("exam_student_answers") as string);
        data = data ?? [];

        let answer: StudentAnswerView = {
            additionalAttachmentId: question.additionalAttachmentId,
            answer: { isWhichOption: answerSelected.isWhichOption, optionText: answerSelected.optionText, orderId: answerSelected.orderId },
            questionAttachmentId: question.questionAttachmentId,
            questionCourseId: question.courseId,
            questionId: question.questionId,
            questionTitle: question.questionTitle
        };
        if (data.length > 0 && data.filter(answer => answer.questionId === question.questionId).length !== 0) {
            var targetAnswer = data.find(answer => answer.questionId === question.questionId);

            if (targetAnswer !== undefined) {
                let index = data.indexOf(targetAnswer);
                data.splice(index, 1);

            }
            if (targetAnswer !== undefined && targetAnswer.answer.isWhichOption !== answer.answer.isWhichOption)
                data.push(answer)

        }
        else
            data.push(answer)

        localStorage.setItem("exam_student_answers", JSON.stringify(data));

        this.setState({ studentAnswers: data });

        let updateData: StudentAnswerView[];
        updateData = [];
        updateData.push(answer);

        var examResultEdition = this.mappingData(updateData);
        this.examResultService.updateExam(examResultEdition).then(function (response) {

        });
    }

    render(): React.ReactNode {
        let { examTimeExpired, questions, showAllQuestion, studentAnswers, examTimeCountDownText } = this.state;

        let questionCheckBox;
        if (!examTimeExpired && questions != null)
            questionCheckBox = (<>

                <label>زمان باقیمانده: <a>{examTimeCountDownText}  </a></label>

                <label className="float-right">
                    <label className="switch">
                        <input type="checkbox" checked={!showAllQuestion} onChange={e => this.setState({ showAllQuestion: !showAllQuestion })} />
                        <span className="slider-badge round">
                        </span>
                    </label>
                </label>
            </>);
        else
            questionCheckBox = (<></>);

        return <>
            <div className="page take-exam-area">
                <div className="main">
                    <div className="header px-12">
                        <div className="title-loc">
                            <span style={{ float: "right" }}>آزمون</span>
                            {/* @if (question != null && question.examResultEdition != null && question.questiosList != null)
                            {
                                <span style={{ float: "right" }}>@question.examResultEdition.ExamStudentAnswers.Count()/@((@question.questiosList.Where(item => item.Questions.Count() > 0).Count() + @question.questiosList.Where(item => item.RelatedQuestions != null).Sum(item => item.RelatedQuestions.Count())))</span>
                            } */}
                        </div>
                    </div>
                    <div className="content-menu px-4">
                        <div className="tk-header">
                            {questionCheckBox}
                        </div>
                        <div className="col-12 notspace">
                            <ExamQuestionView courseIds={this.state.courseIds} structure={this.state.structure} onFinishExam={this.endExam} updateExam={this.updateExam} examTimeExpired={examTimeExpired} questions={questions} showAllQuestion={showAllQuestion} studentAnswers={studentAnswers} />
                        </div>
                    </div>
                </div>
            </div>
        </>;
    }
}

